/**
 * Shared localStorage cache used by Home + PDP for stale-while-revalidate
 * rendering. Returning a cached snapshot for the very first paint eliminates
 * the "blank/empty content for 1-2 seconds while the API loads" flash that
 * production users saw as a "preview-site flash".
 *
 * Keys are namespaced (xyz_*_v1) so the cache can be busted by bumping the
 * version suffix if the backend response shape ever changes.
 */
const VERSION = "v1";
const NS = "xyz";

export const cacheKey = (name, id = "") => `${NS}_${name}${id ? `_${id}` : ""}_${VERSION}`;

export const readCache = (key, fallback = null) => {
  try {
    const raw = localStorage.getItem(key);
    if (!raw) return fallback;
    return JSON.parse(raw);
  } catch {
    return fallback;
  }
};

export const writeCache = (key, value) => {
  try {
    localStorage.setItem(key, JSON.stringify(value));
  } catch {
    // localStorage full or disabled — silently skip; next paint will fetch fresh.
  }
};

export const clearCache = (key) => {
  try { localStorage.removeItem(key); } catch { /* noop */ }
};
